// extracted by mini-css-extract-plugin
module.exports = {"uploadWrapper":"InputUploadSection_uploadWrapper__ZQos_","styledInput":"InputUploadSection_styledInput__SVVhi","buttonColorToggle":"InputUploadSection_buttonColorToggle__Xgv_H"};